import type { EditorSDK } from '@wix/platform-editor-sdk';

import * as constants from '../constants';
import * as componentsWrapper from '../wrappers/components';
import * as tpa from '../wrappers/tpa';

const isMyAccountLayoutHorizontal = async ({ editorSDK }: { editorSDK: EditorSDK }) => {
  try {
    const myAccountComps = await tpa.getAllCompsByAppDefinitionId({
      editorSDK,
      appDefinitionId: constants.MY_ACCOUNT_APP_DEF_ID,
    });
    const myAccountCompRef = await componentsWrapper.getById({ editorSDK, id: myAccountComps[0].id });
    const myAccountLayout = await componentsWrapper.getComponentLayout({ editorSDK, componentRef: myAccountCompRef });
    return myAccountLayout.x < 100;
  } catch (e) {
    return true;
  }
};

export { isMyAccountLayoutHorizontal };
